import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'

import { doc, getDoc, setDoc } from 'firebase/firestore'
import toast from 'react-hot-toast'
import { AiOutlineDelete } from 'react-icons/ai'
import { GrAdd } from 'react-icons/gr'
import { RiDeleteBin7Line } from 'react-icons/ri'
import { RxCross2 } from 'react-icons/rx'
import { TiDelete, TiDeleteOutline } from 'react-icons/ti'
import { useLocation } from 'react-router-dom'

import { Button, Input } from '..'
import { useUser } from '../../context'
import { firestore } from '../../firebase/firebaseConfig'
import { subscribeToDocumentChanges } from '../../firebase/utils/documentsActions'
import { updateAList } from '../../firebase/utils/lists'
import { capitalizeFirstLetter } from '../../utilFunctions/transformFunc'

import { NavbarContainer, NavbarLinkContainer, NewItemRow } from './styles'

interface InlineMenuProps {
  menuName: string
  userType?: string | null
  // menuItems: string[]
  activeFilter: string | string[] | null
  isDisabled?: boolean
  setActiveFilter: (
    value: string | string[] | null,
    filterName?: string,
  ) => void
  isProfile?: boolean
}

const InlineMenu = ({
  menuName,
  userType,
  // menuItems,
  activeFilter,
  isDisabled,
  setActiveFilter,
  isProfile = false,
}: InlineMenuProps) => {
  const { onEditionMode } = useUser()
  const { pathname } = useLocation()

  const [addItem, setAddItem] = useState<boolean>(false)
  const [newItem, setNewItem] = useState<string>()
  const [menuItems, setMenuItems] = useState([])

  const isActive = (item: string) => {
    if (Array.isArray(activeFilter)) {
      return activeFilter.includes(item)
    }
    return activeFilter === item
  }

  const handleClickButton = (item: string) => {
    // console.log(activeFilter, 'activeFilter', Array.isArray(activeFilter))
    if (Array.isArray(activeFilter)) {
      if (activeFilter.includes(item)) {
        setActiveFilter(
          activeFilter.filter((filterItem) => filterItem !== item),
        )
      } else {
        setActiveFilter([...activeFilter, item])
      }
    } else {
      setActiveFilter(item)
    }
  }

  const checkAndAddListener = useCallback(async () => {
    if (menuName) {
      // TODO: Replace with
      // const menu = await guardedCall(() => getDoc(doc(firestore, 'lists', menuName)))
      try {
        const docRef = doc(firestore, 'lists', menuName)
        const docSnapshot = await getDoc(docRef)

        if (!docSnapshot.exists()) {
          await setDoc(docRef, { items: [] })
        }
        subscribeToDocumentChanges('lists', menuName, setMenuItems)
      } catch (error) {
        console.error('Error accediendo o creando el documento:', error)
      }
    }
  }, [menuName])

  const addItemToList = async () => {
    if (!newItem) return
    if (userType === 'admin' && menuName && addItem) {
      try {
        updateAList(menuName, newItem, 'menu')

        setNewItem('')
      } catch (error) {
        console.error('Error al verificar o actualizar el documento:', error)
        toast.error('Error al agregar el item')
      }
    } else {
      setAddItem(true)
    }
  }

  const handleRemoveItem = async (item: string) => {
    if (userType === 'admin' && menuName !== 'professorsNames') {
      try {
        updateAList(menuName, item, 'menu')
      } catch (error) {
        console.error('Error al verificar o actualizar el documento:', error)
        toast.error('Error al eliminar el item')
      }
    }
  }

  const handleItem = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value.trim()) return

    setNewItem(e.target.value)
  }

  useEffect(() => {
    checkAndAddListener()
  }, [])

  return (
    <NavbarContainer>
      <NavbarLinkContainer>
        {menuItems.length > 0 &&
          menuItems.map((item: string | { name: string; uid: string }, i) => {
            const _item = typeof item === 'string' ? item : item.name
            return (
              <div key={i} style={{ position: 'relative' }}>
                <Button
                  className={`inline-menu ${isProfile ? 'profile-item' : undefined} ${isActive(_item) ? 'active' : undefined}`}
                  onClick={() => handleClickButton(_item)}
                  disabled={isDisabled || addItem}
                  label={capitalizeFirstLetter(_item)}
                />
                {userType === 'admin' &&
                  menuName !== 'professorsNames' &&
                  (onEditionMode || pathname === '/nuevo-usuario') &&
                  addItem && (
                    <Button
                      className="delete"
                      onClick={() => handleRemoveItem(_item)}
                      label={<RxCross2 />}
                      fontSize={12}
                      style={{
                        padding: 2,
                        backgroundColor: '#E67373',
                        color: '#ffffff',
                        position: 'absolute',
                        top: '-6px',
                        right: '-6px',
                      }}
                    />
                  )}
              </div>
            )
          })}
        {(onEditionMode || pathname === '/nuevo-usuario') && (
          <NewItemRow>
            {addItem && (
              <>
                <Input
                  name="newItem"
                  id="newItem"
                  value={newItem}
                  onChange={handleItem}
                  width="300px"
                />
                <Button onClick={addItemToList} label="Agregar Item" />
              </>
            )}

            {userType === 'admin' && menuName !== 'professorsNames' && (
              <Button
                className="dark-grey"
                onClick={() => setAddItem(!addItem)}
                label={addItem ? 'Terminar' : 'Editar items'}
              />
            )}
          </NewItemRow>
        )}
      </NavbarLinkContainer>
    </NavbarContainer>
  )
}

export default InlineMenu
